export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"google-site-verification","content":"wHct8wjwZdesKo8bLVGn_7uRusn5qqoDVJgHd-wIo8U"},{"hid":"description","name":"description","content":"毎年大人気の英語力測定テストが、今年は英会話編にリニューアル！街中で困った様子のねずみくんに英語で話しかけられた！3つの選択肢から適切な回答を選んで、ねずみくんを助けよう。問題に使用されている英単語や文法は、すべて中学英語レベル。10問中何問正解できるかな。あなたの英語力を手軽にチェックしてみよう！"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","property":"og:site_name","content":"NHK出版"},{"hid":"og:url","property":"og:url","content":"https://eigoryoku.nhk-book.co.jp"},{"hid":"og:title","property":"og:title","content":"英語クイズ ～街ナカ英会話編 | 英語力測定テスト | NHK出版"},{"hid":"og:site_name","property":"og:site_name","content":"NHK出版"},{"hid":"og:description","property":"og:description","content":"毎年大人気の英語力測定テストが、今年は英会話編にリニューアル！街中で困った様子のねずみくんに英語で話しかけられた！3つの選択肢から適切な回答を選んで、ねずみくんを助けよう。問題に使用されている英単語や文法は、すべて中学英語レベル。10問中何問正解できるかな。あなたの英語力を手軽にチェックしてみよう！"},{"hid":"twitter:title","name":"twitter:title","content":"英語クイズ ～街ナカ英会話編 | 英語力測定テスト | NHK出版"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"＠nhkp_gogakucafe"},{"hid":"og:image:width","property":"og:image:width","content":"1200"},{"hid":"og:image:height","property":"og:image:height","content":"630"},{"hid":"twitter:image","name":"twitter:image","content":"https://eigoryoku.nhk-book.co.jp/ogp.png?v4"},{"hid":"og:image","property":"og:image","content":"https://eigoryoku.nhk-book.co.jp/ogp.png?v4"}],"link":[],"style":[],"script":[],"noscript":[],"title":"英語クイズ ～街ナカ英会話編 | 英語力測定テスト | NHK出版","htmlAttrs":{"lang":"ja","prefix":"og: http://ogp.me/ns#"}}

export const appBaseUrl = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnUrl = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'